import axios from 'axios';
import { useQuery } from 'react-query';

import { useSessionStore } from 'session/useSessionStore';

export const useDownloadImage = (imageToken?: string) => {
    const [fileManagerHost, projectToken, jwt] = useSessionStore(state => [state.tenantConfiguration?.endpoints.fileManager, state.tenantConfiguration?.tenantToken, state.jwtToken]);;

    return useQuery<Blob>(['fileManager.DownloadImage', imageToken],
        async () => {
            const response = await axios.get<Blob>(`${fileManagerHost}/Filemanager/Filemanager/DownloadFile?fileToken=${imageToken}&tenantToken=${projectToken}`, {
                headers: {
                    Authorization: 'Bearer ' + jwt
                },
                responseType: 'blob'
            });
            return response.data;
        },
        {
            enabled: !!imageToken
        }
    );
};